<template>
  <section class="about-area ptb-70">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="about-content">
            <span><h3>Merchant Feedback</h3></span>
            <h5>Here is what some of our mechants have to say</h5>
            <p></p>
          </div>
        </div>

        <div class="col-lg-6 col-md-12">
          <div class="about-image">
            <img src="assets/img/about-img1.jpg" alt="image" />

            <a
              type="button"
              data-toggle="modal"
              data-target="#videomodal"
              class="video-btn popup-youtube"
              v-on:click="openModal()"
            >
              <i class="fas fa-play"></i>
            </a>
          </div>
        </div>

        <div id="videomodal" class="modal">
          <div class="modal-header">
            <button data-dismiss="modal" type="button" class="close" v-on:click="closeModal()" >&times;</button>
          </div>
          <iframe ref="iframeModalWindow" src="https://www.youtube.com/embed/GiyqGbBd0EY" name="iframe_modal"></iframe>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    closeModal() {
      this.$refs.iframeModalWindow.src=""
    },
    openModal() {
      this.$refs.iframeModalWindow.src="https://www.youtube.com/embed/GiyqGbBd0EY"
    }
  }
};
</script>
<style scoped>
.close {
  color: white;
  font-size: 40px;
}
.modal iframe {
  width: 800px;
  height: 600px;
  margin-left: 0%;
 
}
.modal-header {
  background-color: red;
  width: 100%;
  margin-left: 5px;
  padding: 0;
  
}
@media only screen and (max-width:767px) {
  .modal iframe {
  width: 100%;
  margin: 0;
 
}
}
</style>